import { StoreActionType as Type } from '../../types'; 
const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const returnDetailsReducer : any = (state = initialState, action:any) => {
  switch (action.type) {
    case Type.GET_RETURN_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case Type.GET_RETURN_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      };
    case Type.GET_RETURN_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

